    <template>
    <form class="g pop-up-inner" :style="styleSet">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '輸入提示'"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <div class="md" v-html="content.html"></div>
                    <div class="md">
                        <cpCombobox
                            :hideLabel="true"
                            showMode="block"
                            :options="option"
                            v-model="value"
                        ></cpCombobox>
                    </div>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </form>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'
    import cpCombobox from '@/components/cpCombobox'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
            cpCombobox,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let $styleSet = {};

            let _width = this.content.width;

            if( _width && typeof _width === 'number' ) {
                $styleSet.width = _width +'px';
            }else if( _width && typeof _width === 'string') {
                $styleSet.width = _width;
            }else {
                $styleSet.width = 'auto';
            }

            return {
                value: '',
                option: [],
                styleSet: $styleSet
            }
        },
        computed: {
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: $content.cancelName || this.$t('site.func.popupclose'),
                        icon: $content.cancelIcon || '',
                        themes: $content.cancelTheme || '',
                        func: 'close',
                    }

                let $results = [].concat($moreBtns);

                $results.push($action);
                $results.push($cancel);

                return $results;
            },
        },
        methods: {
            sendFuncEvent: function(func){ //多 btn 功能

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {
                        let $content = this.content,
                            _value = this.value;

                        $content[func](_value);
                    }
                });
            },
            action: function(){

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {
                        let $content = this.content,
                            $_action = $content.action,
                            _value = this.value;

                        if( $content.actionStopClose !== true ) {
                            this.close();
                        }

                        $_action(_value);
                    }
                });
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
            setValue: function(){
                let $content = this.content,
                    _value = $content.value;

                if( _value ) {
                    this.$set(this, 'value', _value);
                }
            },
            setData: function(){
                let $content = this.content,
                    $options = $content.options; //可以是 Object 也可以是 Array

                this.$set(this, 'option', $options);
            }
        },
        created: function(){
            this.setData();
            this.setValue();
        }
    }
</script>

<style scoped lang="scss">

    .pop-up-content {

        .md {

            + .md {
                margin-top: 6px;
            }
        }
    }

    .input {
        width: 100%;
    }
</style>
